import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/86f42358ac7b1d8465d2d62b9f031353.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="max-w-4xl">
          <div className="h-px w-24 bg-white/40 mb-8"></div>
          
          <p className="text-xs uppercase tracking-widest text-gray-300 mb-8 font-medium">
            INSTITUTIONAL FUNDING STRATEGY
          </p>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-8">
            Get Funded the Right Way —<br />
            <span className="font-semibold">Business & Personal Funding</span><br />
            <span className="text-gray-200">Without the Games</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 leading-relaxed mb-12 max-w-2xl">
            We prepare, position, and package you to qualify for real approvals — not guesses. Professional funding strategy and business credit consulting that delivers results.
          </p>

          <div className="flex flex-col sm:flex-row gap-5">
            <Link
              to="/apply"
              className="inline-flex items-center justify-center bg-navy text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-navy-light transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Check My Funding Options
              <i className="ri-arrow-right-line ml-2 text-lg"></i>
            </Link>
            <Link
              to="/apply"
              className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-white hover:text-navy transition-all whitespace-nowrap cursor-pointer"
            >
              Apply Now
            </Link>
          </div>

          <div className="flex items-center gap-8 mt-16 pt-8 border-t border-white/20">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <span className="text-sm text-gray-300">Compliance First</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-verified-badge-line text-2xl text-white"></i>
              </div>
              <span className="text-sm text-gray-300">Proven Strategy</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <span className="text-sm text-gray-300">Expert Guidance</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
